import { baseSort } from "./general.utils";

export const setIsFetching = (state) => {
  return {
    ...state,
    isFetching: true
  }
};

export const filterIpoResults = (state, data) => {
  return {
    ...state,
    isFetching: false,
    ipoResults: data
  };
};

export const resetIpoResults = (state, data) => {
  return {
    ...state,
    isFetching: false,
    ipoResults: [],
    errorMessage: data
  };
};

export const sortType = [
  {
    value: 'date',
    label: 'ตามวันที่'
  },
  {
    value: 'risk',
    label: 'ตามความเสี่ยง'
  },
  {
    value: 'investAmount',
    label: 'ตามเงินลงทุน'
  },
  {
    value: 'returnAmount',
    label: 'ตามผลตอบแทน'
  },
  {
    value: 'fee',
    label: 'ตามค่าธรรมเนียม'
  }
]

export	const sortItems = (items, sortType) => {
  if (!items) {
    return undefined;
  }

  let result;
  switch (sortType) {
    case 'date':
      result = items.sort( (a, b) => baseSort(new Date(a.sellEndedAt), new Date (b.sellEndedAt), 'a') || baseSort(a.fundCode, b.fundCode, 'a'));
      break;
    case 'risk':
      result = items.sort( (a, b) => baseSort(a.riskLevel, b.riskLevel, 'a') || baseSort(a.fundCode, b.fundCode, 'a'));
      break;
    case 'investAmount':
      result = items.sort( (a, b) => baseSort(a.initialPurchase, b.initialPurchase, 'a') || baseSort(a.fundCode, b.fundCode, 'a'));
      break;
    case 'returnAmount':
      result = items.sort( (a, b) => baseSort(a.forecastingReturn, b.forecastingReturn, 'd') || baseSort(a.fundCode, b.fundCode, 'a'));
      break;
    case 'fee':
      result = items.sort( (a, b) => baseSort(a.purchaseFee, b.purchaseFee, 'a') || baseSort(a.fundCode, b.fundCode, 'a'));
      break;
    default:
      result = items
      break;
  }

  return result;
}

export const isInRangeDate = (checkedDate, startDate, endDate) => {
  if (!checkedDate || !startDate || !endDate) {
    return false;
  }
  return  startDate.getTime() <= checkedDate.getTime() && checkedDate.getTime() <= endDate.getTime()
}